var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var DashboardDetailsModel = GenericModel.extend(
{
    urlRoot : '/rest/api/user/dashboard',
    id : null,
    averageWaitTime: 0.0000000,
    maxWaitTime: 0.0000000,
    activeQueuesCount: 0,
    totalVenuesCount: 0,
    dashboardVenue: null,
    dashboardVenues: [],
    dashboardQueues: []
});

module.exports = DashboardDetailsModel;